'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _outfeatNavigation = require('../../redux/modules/outfeatNavigation');

var _components = require('components');

var _Discover = require('./Discover.scss');

var _Discover2 = _interopRequireDefault(_Discover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discover = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: state.discover.isLoading,
    outfeats: state.discover.outfeats.map(function (oid) {
      return state.entities.outfeats[oid];
    })
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Discover, _Component);

  function Discover() {
    (0, _classCallCheck3.default)(this, Discover);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Discover).apply(this, arguments));
  }

  (0, _createClass3.default)(Discover, [{
    key: 'renderList',
    value: function renderList() {
      var _this2 = this;

      return this.props.outfeats.map(function (outfeat, index) {
        if (outfeat.images) {
          return _react2.default.createElement(_components.OutfeatPreview, {
            key: 'outfeat-' + outfeat.id,
            outfeat: outfeat,
            onSelect: function onSelect() {
              _this2.props.dispatch((0, _outfeatNavigation.setFromPage)('discover'));
            }
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var outfeats = _props.outfeats;
      var isLoading = _props.isLoading;

      if (isLoading && outfeats.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: _Discover2.default.loading },
          _react2.default.createElement('div', { className: _Discover2.default.loader }),
          _react2.default.createElement(
            'p',
            null,
            'Loading outfeat grid...'
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Discover' }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_Discover2.default.outfits) },
          _react2.default.createElement(
            'div',
            { className: _Discover2.default.titleContainer },
            _react2.default.createElement(
              'h1',
              { className: _Discover2.default.title },
              'Discover'
            )
          ),
          this.renderList()
        )
      );
    }
  }]);
  return Discover;
}(_react.Component), _class2.propTypes = {
  outfeats: _react.PropTypes.array,
  isLoading: _react.PropTypes.bool
}, _class2.defaultProps = {
  outfeats: [],
  isLoading: true
}, _temp)) || _class);
exports.default = Discover;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Discover/Discover.js
 ** module id = 1108
 ** module chunks = 0
 **/